import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PostingOrderService } from '../posting-order.service';
import { CommonService } from '../Model/Common/common.service';
import { SessionService } from '../Util/Session/session.service';
import { ComboService } from '../Model/Combo/combo.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';

@Component({
  selector: 'app-posting-order-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgSelectModule],
  templateUrl: './posting-order-form.component.html',
  styleUrl: './posting-order-form.component.scss'
})
export class PostingOrderFormComponent {

  isDisabled: boolean = false;
  IsSubContractor: boolean = false;
  InvalidDate = false;
  user: any;

  BranchLoad: any[] = [];
  Vendors: any[] = [];
  ShiftLoad: any[] = [];
  EmployeeLoad: any[] = [];
  EmployeeLoadSub: any[] = [];
  CustomerLoad: any[] = [];
  LocationLoad: any[] = [];
  EmployeeDesignationLoad: any[] = [];
  DutyLoad: any[] = [];

  Filter = {
    SelectType: 1,
    ID: null as any,
    BranchCode: null,
    PostingOrderNo: null as any,
    CompanyMasterID: 1,
    ERPBranchID: null,
    City: null,
    BranchID: null as any,
    EmployeeMasterID: null,
    CustomerMasterID: null,
    LocationMasterID: null,
    EmployeeDesignationID: null,
    Duty: null,
    Shift: null,
    EffectiveDate: null as any,
    PostingDate: null as any,
    PostingOrderID: null as any,
    EmployeeName: '',
    EmployeeDesignationName: '',
    JoiningDate: null as any,
    CREATEDBY: 0,
    VendorId: 0,
    VendorName: ''
  }

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private PostingOrder: PostingOrderService,
    private commonService: CommonService,
    private session: SessionService,
    private combo: ComboService,
    private toast: ToastService
  ) {
    // this.common.getPageRights();
    this.IsSubContractor = window.location.pathname.includes('postingordersub');
    this.route.params.subscribe(params => this.Filter.PostingOrderID = parseInt(params['id']));
    this.user = this.session.GetUserDetails();
    this.Filter.CREATEDBY = this.user.UserId;
  }

  async ngOnInit() {
    this.GetTodaysDate();
    this.ESS_FillComboOAS('Vendor');
    await this.ComboLoad('Branch');
    if (this.Filter.PostingOrderID > 0) {
      this.GetData();
    }
  }

  GetTodaysDate() {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    this.Filter.PostingDate = formattedDate;
  }

  ESS_FillComboOAS(Type: String) {
    this.isDisabled = true;
    return this.PostingOrder.ESS_FillComboOAS({ 'SelectType': Type }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (Type == "Vendor") {
            this.Vendors = response.Table;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;

    if (Combotype === 'Site') {
      this.Filter.LocationMasterID = null;
      this.LocationLoad = [];
      this.Filter.EmployeeDesignationID = null;
      this.EmployeeDesignationLoad = [];
      this.Filter.Duty = null;
      this.DutyLoad = [];
      this.Filter.Shift = null;
    } else if (Combotype == 'Designation'){
      this.Filter.EmployeeDesignationID = null;
      this.EmployeeDesignationLoad = [];
      this.Filter.Duty = null;
      this.DutyLoad = [];
      this.Filter.Shift = null;
    } else if (Combotype == 'Duty'){
      this.Filter.Duty = null;
      this.DutyLoad = [];
      this.Filter.Shift = null;
    } else if (Combotype == 'ShiftLoadBasedOnDesignationDuty'){
      this.Filter.Shift = null;
    }

    return new Promise((resolve, reject) => {
      this.combo.ComboLoad({
        'Combotype': Combotype,
        'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.BranchID : 0,
        'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.CustomerMasterID : 0,
        'SiteId': (Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.LocationMasterID : 0,
        'DesignationId': (Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.EmployeeDesignationID : 0,
        'DutyId': (Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.Filter.Duty : 0,
        'EmpType': 'Front'
      }).subscribe({
        next: (response) => {
          if (Combotype == 'ShiftLoadBasedOnDesignationDuty') {
            this.ShiftLoad = response.ComboLoad
          } else if (Combotype == 'Designation') {
            this.EmployeeDesignationLoad = response.ComboLoad
          } else if (Combotype == 'Duty') {
            this.DutyLoad = response.ComboLoad
          } else if (Combotype == 'Branch') {
            this.BranchLoad = response.ComboLoad
          } else if (Combotype == 'Client') {
            this.CustomerLoad = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.LocationLoad = response.ComboLoad;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  async GetData() {
    this.PostingOrder.PostingOrder({
      PostingOrderID: this.Filter.PostingOrderID
    }).subscribe({
      next: async (response) => {
        const data = response.Table[0];
        this.Filter.PostingOrderNo = data.PostingOrderNumber;
        this.Filter.BranchID = data.BranchID;

        await this.ComboLoad('Client');
        this.IsSubContractor ? await this.ESS_EmployeeSubcontracterSelect() : await this.FillCombo('Posting Order Branch');

        this.Filter.EmployeeMasterID = data.EmployeeID;
        this.GetDataOnEmployeeLoad(this.Filter.EmployeeMasterID);

        this.Filter.CustomerMasterID = data.CustomerID;

        await this.ComboLoad('Site');
        this.Filter.LocationMasterID = data.SiteID;
        await this.ComboLoad('Designation');
        this.Filter.EmployeeDesignationID = data.DesignationID;

        await this.ComboLoad('Duty');
        this.Filter.Duty = data.DutyID;
        await this.ComboLoad('ShiftLoadBasedOnDesignationDuty');
        this.Filter.Shift = data.ShiftId;
        this.Filter.EffectiveDate = data.EffectDateFrom.split('/')[2] + '-' + data.EffectDateFrom.split('/')[1] + '-' + data.EffectDateFrom.split('/')[0]
        this.Filter.PostingDate = data.TransactionDate.split('/')[2] + '-' + data.TransactionDate.split('/')[1] + '-' + data.TransactionDate.split('/')[0]

        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_EmployeeSubcontracterSelect() {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.ESS_EmployeeSubcontracterSelect({
        SubType: 'A',
        SelectType: 'EW'
      }).subscribe({
        next: async (response) => {
          this.EmployeeLoad = [...response.Table, response.Table.map((e: any) => e.Code = (e.FirstName + ' ' + e.LastName))];
          resolve(true);
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  GetDataOnEmployeeLoad(empId: any) {
    this.isDisabled = true;
    this.PostingOrder.GetDataOnComboLoad({
      SelectType: "Posting Order",
      ID: empId,
    }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.Filter.EmployeeDesignationID = null;
          this.Filter.EmployeeName = '';
          this.Filter.VendorName = '';
          this.Filter.VendorId = 0;
        } else {
          const data = response.Table[0];
          this.Filter.EmployeeDesignationName = data['DesignationName'];
          this.Filter.JoiningDate = data['JoiningDate'].split('/')[2] + '-' + data['JoiningDate'].split('/')[1] + '-' + data['JoiningDate'].split('/')[0];
          this.Filter.EmployeeName = data.EmpName;
          this.Filter.VendorId = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EmployeeMasterID).VendorId;
          this.Filter.VendorName = this.EmployeeLoad.find((item: any) => item.EmpMasterID == this.Filter.EmployeeMasterID).VendorName;
          if (data.NoOfAllotment == 0) {
            this.Filter.EffectiveDate = data.JoiningDate.split('/')[2] + '-' + data.JoiningDate.split('/')[1] + '-' + data.JoiningDate.split('/')[0]
          } else {
            const today = new Date();
            const formattedDate = today.toISOString().split('T')[0];
            this.Filter.EffectiveDate = formattedDate;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FillCombo(Combotype: String, ID1: number = 0, ID2: number = 0): Promise<any> {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.FillCombo({
        'SelectType': Combotype,
        'BranchID': this.Filter.BranchID,
        'ID1': Combotype == 'Location Master for Entry' ? this.Filter.CustomerMasterID : ID1,
        'Code1': '',
        'ID2': this.Filter.PostingOrderID,
        'Code2': '',
        'ID3': '',
        'Code3': '',
        // 'EmpType': 'Front',
      }).subscribe({
        next: (response) => {
          if (Combotype === 'Branch Master') {
            this.BranchLoad = response.Table
          } else if (Combotype === 'ClientGroupIDByBranch') {
            this.CustomerLoad = response.Table
          } else if (Combotype === 'Posting Order Branch') {
            this.EmployeeLoad = response.Table
          } else if (Combotype === 'Location Master for Entry') {
            this.LocationLoad = response.Table
          } else if (Combotype === 'Allotment Shift Master') {
            this.ShiftLoad = response.Table
          } else if (Combotype == 'Posting Order' && ID1 == 3) {
            this.DutyLoad = response.Table
          } else if (Combotype == 'Posting Order' && ID1 == 2) {
            this.EmployeeDesignationLoad = response.Table
          }
          this.isDisabled = false;
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to save?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.InsertUpdate();
      }
    }).catch(() => {

    });
  }

  async InsertUpdate() {
    await this.ValidateEffectiveDate(this.Filter.EmployeeMasterID);
    if (this.InvalidDate) {
      return;
    }
    this.isDisabled = true;
    const Detail = {
      SELECTTYPE: this.Filter.PostingOrderID > 0 ? 11 : 1,
      BRANCHID: this.Filter.BranchID,
      TRANSACTIONDATE: this.Filter.PostingDate,
      EMPLOYEEID: this.Filter.EmployeeMasterID,
      FROM_CUSTOMERID: 0,
      FROM_SITEID: 0,
      TO_CUSTOMERID: this.Filter.CustomerMasterID,
      TO_SITEID: this.Filter.LocationMasterID,
      FROMDATE: this.Filter.EffectiveDate,
      TODATE: this.Filter.EffectiveDate,
      REASONID: 0,
      REMARKS: '',
      DESIGNATIONID: this.Filter.EmployeeDesignationID,
      ALLOTMENTID: this.Filter.PostingOrderID,
      DUTYID: this.Filter.Duty,
      SHIFTID: this.Filter.Shift,
      VendorId: this.Filter.VendorId
    }
    this.PostingOrder.PostingOrderInsertUpdate(Detail).subscribe({
      next: (response) => {
        if (response.STATUS == 1) {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.IsSubContractor ? this.router.navigate(['/allocation/postingordersub']) : this.router.navigate(['/allocation/postingorder']);
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    })
  }

  ValidateEffectiveDate(empId: any) {
    this.InvalidDate = false;
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.PostingOrder.GetDataOnComboLoad({
        SelectType: "Branch Transfer Date",
        ID: empId,
      }).subscribe({
        next: (response) => {
          let effectiveDate = new Date(this.Filter.EffectiveDate);
          let joiningDate = new Date(this.Filter.JoiningDate);
          if (response.Table.length > 0) {
            let fromdate = response.Table[0].From_Date;
            let fromdateformatted = new Date(fromdate.split('/')[2] + '-' + fromdate.split('/')[1] + '-' + fromdate.split('/')[0]);

            if (fromdateformatted.toString() !== effectiveDate.toString()) {
              this.toast.show({ message: `Posting Order Date should be equal to ${fromdate} - Branch Transfer Date`, type: toastTypeEnum.warning });
              this.InvalidDate = true;
              this.isDisabled = false;
              return;
            }
          }

          if (joiningDate > effectiveDate) {
            this.toast.show({ message: `Posting Order Date should be greater than / equal to ${this.Filter.JoiningDate} (Joining Date)`, type: toastTypeEnum.warning })
            this.InvalidDate = true;
            this.isDisabled = false;
            return;
          }
          resolve(true);
        },
        complete: () => {
          this.isDisabled = false;
        },
        error: (error) => {
          this.isDisabled = false;
          reject(error);
        },
      });
    })
  }

  async OnBranchChange() {
    this.EmployeeLoad = [];
    this.ComboLoad('Client');
    this.IsSubContractor ? await this.ESS_EmployeeSubcontracterSelect() : await this.FillCombo('Posting Order Branch');
    this.Filter.EmployeeMasterID = null;
    this.Filter.EmployeeName = '';
    this.Filter.CustomerMasterID = null;
    //// this.CustomerLoad = [];
    this.Filter.LocationMasterID = null;
    this.LocationLoad = [];
    this.Filter.EmployeeDesignationID = null;
    this.EmployeeDesignationLoad = [];
    this.Filter.Duty = null;
    this.DutyLoad = []
    this.Filter.Shift = null;
  }

  LoadEmployeeDesignation() {
    const designation = this.EmployeeDesignationLoad.find(x => x.DesignationName === this.Filter.EmployeeDesignationName);
    if (designation) {
      this.Filter.EmployeeDesignationID = designation.DesignationMasterID;
    }
  }

  PostingOrderPrint() {
    this.isDisabled = true;
    this.PostingOrder.PostingOrderReport({
      ID: this.Filter.PostingOrderID,
      BranchID: this.Filter.BranchID
    }).subscribe({
      next: (response) => {
        window.open(response.FullFileName, '_blank')
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  cancel() {
    this.IsSubContractor ? this.router.navigate(['/allocation/postingordersub']) : this.router.navigate(['/allocation/postingorder']);
  }

}
